import Workspace from "../../../core/internal/workspace/Workspace"
import { HackleUser, InAppMessage, InAppMessageEventTriggerRule } from "../../../core/internal/model/model"
import UserEvent, { TrackEvent } from "../../../core/internal/event/UserEvent"
import TargetMatcher from "../../../core/internal/evaluation/match/TargetMatcher"
import {
  EvaluatorContext,
  EvaluatorKey,
  EventEvaluatorRequest
} from "../../../core/internal/evaluation/evalautor/Evaluator"

export interface InAppMessageEventTriggerMatcher {
  matches(workspace: Workspace, inAppMessage: InAppMessage, event: TrackEvent): boolean
}

export class InAppMessageEventTriggerRuleMatcher implements InAppMessageEventTriggerMatcher {
  constructor(private targetMatcher: TargetMatcher) {}

  public matches(workspace: Workspace, inAppMessage: InAppMessage, event: TrackEvent): boolean {
    return inAppMessage.eventTrigger.rules.some((it) => this.ruleMatches(workspace, event, inAppMessage, it))
  }

  private ruleMatches(
    workspace: Workspace,
    event: TrackEvent,
    inAppMessage: InAppMessage,
    rule: InAppMessageEventTriggerRule
  ): boolean {
    if (event.event.key !== rule.eventKey) {
      return false
    }
    const request = EvaluatorRequest.of(workspace, event, inAppMessage)
    return this.targetMatcher.anyMatches(request, EvaluatorContext.create(), rule.targets)
  }
}

class EvaluatorRequest implements EventEvaluatorRequest {
  private constructor(
    public readonly key: EvaluatorKey,
    public readonly workspace: Workspace,
    public readonly user: HackleUser,
    public readonly event: UserEvent
  ) {}

  static of(workspace: Workspace, event: UserEvent, inAppMessage: InAppMessage): EvaluatorRequest {
    return new EvaluatorRequest(new EvaluatorKey("IN_APP_MESSAGE", inAppMessage.id), workspace, event.user, event)
  }
}
